<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { flushOfflineQueue,offlineQueueCount } from '@/services/offlineQueue'

const online = ref(navigator.onLine)
const statusLabel = computed(() => online.value ? 'Connexion rétablie' : 'Mode hors ligne')
const setOnline = () => { online.value = navigator.onLine }
const pending=ref(0),syncing=ref(false),syncError=ref('')
const refreshPending=async()=>pending.value=await offlineQueueCount()
const syncState=(e:Event)=>syncing.value=(e as CustomEvent).detail==='syncing'
const syncFailed=(e:Event)=>syncError.value=String((e as CustomEvent).detail||'')

onMounted(() => {
  window.addEventListener('online', setOnline)
  window.addEventListener('offline', setOnline)
  window.addEventListener('offline:queue-changed',refreshPending)
  window.addEventListener('offline:sync-state',syncState)
  window.addEventListener('offline:sync-error',syncFailed)
  void refreshPending();if(online.value)void flushOfflineQueue()
})
onUnmounted(() => {
  window.removeEventListener('online', setOnline)
  window.removeEventListener('offline', setOnline)
  window.removeEventListener('offline:queue-changed',refreshPending)
  window.removeEventListener('offline:sync-state',syncState)
  window.removeEventListener('offline:sync-error',syncFailed)
})
</script>

<template>
  <div v-if="!online||pending||syncing||syncError" class="offline-banner"><span>{{!online?statusLabel:syncing?'Synchronisation en cours':pending?`${pending} opération(s) à synchroniser`:'Connexion rétablie'}}</span><button v-if="online&&pending&&!syncing" type="button" @click="syncError='';flushOfflineQueue()">Synchroniser</button><small v-if="syncError">{{syncError}}</small></div>
  <RouterView />
</template>
